import client from '/src/services/client.js';

export default {
    getConversations : (data) => client.get('conversations/inprogress', data),
    getConversation : ({id}) => client.get(`conversation/inprogress/${id}`, {}),
}
